import React, { useEffect } from "react"
import types from "prop-types"
import { isEqual } from "lodash-es"
import { useSelector } from "react-redux"
import { activityHubUsers } from "reduxSlices/organizationUsersSlice"
import { useTaskFormContext } from "contexts/TaskFormContext"
/* eslint-disable-next-line max-len */
import TaskUserSelector from "views/FormSubmission/FormSubmissionTabs/ActivitiesContent/TaskForms/TaskFields/UI/TaskUserSelector"

const TaskMemberSelector = ({ className = "" }) => {
  const users = useSelector(activityHubUsers, isEqual)

  const { addMemberId, taskAssigneeIds, taskMemberIds } = useTaskFormContext()

  useEffect(() => {
    window.dispatchEvent(new window.Event("resize"))
  }, [taskMemberIds.length])

  const selectableUsers = users.reduce((userList, user) => {
    if (user.active && !taskMemberIds.includes(user.id)) {
      userList.push(
        {
          ...user,
          ...(taskAssigneeIds.includes(user.id) && { marker: "Assignee" }),
        },
      )
    }
    return userList
  }, [])

  return (
    <TaskUserSelector
      addUserId={addMemberId}
      className={className}
      taskUserType="Members"
      users={selectableUsers}
    />
  )
}

TaskMemberSelector.propTypes = {
  className: types.string,
}

export default TaskMemberSelector
